import ModalPages from 'constants/ModalPages';

const isModalPage = (url) => ModalPages.includes(url);
export default isModalPage;
